<template lang="pug">
div
  app-collapse(title="Área a ser permutada")
    app-display(
      label="N° do título:",
      :content="imovel.numeroTitulo",
      :marginBottom="true",
      :class = "compararImovelPermuta && compararImovelPermuta.mudouNumeroTitulo ? 'text': '' "
    )
    app-display(
      v-if="inputsExtraCadastro.imovel.nomeImovelPropriedade"
      label="Nome do imóvel/Propriedade:",
      :content="imovel.nomeImovelPropriedade",
      :marginBottom="true",
      :class = "compararImovelPermuta && compararImovelPermuta.mudouNomeImovelPropriedade ? 'text': '' "
    )
    app-display(
      label="Causas da impossibilidade de ocupação:",
      :content="imovel.causasImpossibilidadeOcupacao",
      :class = "compararImovelPermuta && compararImovelPermuta.mudouCausasImpossibilidadeOcupacao ? 'text': '' "
    )
  app-collapse(title="Área de interesse")
    app-display(
      label="Número do recibo:",
      :content="imovel.numeroReciboCar",
      :marginBottom="true",
      :class = "compararImovelPermuta && compararImovelPermuta.mudouNumeroReciboCar ? 'text': '' "
    )
    app-display(
      label="Tempo de ocupação (em anos):",
      :content="tempoOcupacaoFormatado",
      :marginBottom="true",
      :class = "compararImovelPermuta && compararImovelPermuta.mudouTempoOcupacao ? 'text': '' "
    )
    app-display(
      label="Há ocupantes anteriores?",
      :content="imovel.ocupantesAnteriores ? 'Sim' : 'Não'",
      :marginBottom="true",
      :class = "compararImovelPermuta && compararImovelPermuta.mudouOcupantesAnteriores ? 'text': '' "
    )
    app-display(
      :label="'Possui outros imóveis rurais no ' + ESTADO + '?'",
      :content="imovel.possuiImovel ? 'Sim' : 'Não'",
      :marginBottom="true",
      :class = "compararImovelPermuta && compararImovelPermuta.mudouPossuiImovel ? 'text': '' "
    )
    app-display(
      label="Há conflitos no imóvel?",
      :content="imovel.conflitos ? 'Sim' : 'Não'",
      :marginBottom="true",
      :class = "compararImovelPermuta && compararImovelPermuta.mudouConflitos ? 'text': '' "
    )
    app-display(
      v-if="imovel.conflitos"
      label="Nº do processo judicial:",
      :content="imovel.numeroProcessoJudicial",
      :class = "compararImovelPermuta && compararImovelPermuta.mudouNumeroProcessoJudicial ? 'text': '' "

    )
</template>
<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import { mapState } from 'vuex'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDisplay,
    AppCollapse
  },

  props: {
    imovel: {
      type: Object,
      required: true
    },
    compararImovelPermuta: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      inputsExtraCadastro
    }
  },

  computed: {
    tempoOcupacaoFormatado () {
      return this.imovel.tempoOcupacao + ' ano(s)'
    },

    ...mapState({
      ESTADO: state => state.userInterface.dadosEstado.ESTADO
    })
  }
}
</script>
<style lang="scss" scoped>
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesImovelPermuta.vue